import { api } from './client';
import { formatEstimateUsd } from '../utils/estimateOutlineCost';

export const DECLARED_FORMATS = [
  { value: 'outline', label: 'Outline' },
  { value: 'flat_notes', label: 'Loose pages' },
  { value: 'transcript', label: 'Pasted AI chat transcript' },
  { value: 'manuscript_draft', label: 'Manuscript draft' },
  { value: 'story_sheet', label: 'Story sheet from outside chat' },
];

export const ACCEPT_EXTENSIONS = '.txt,.md,.markdown,.docx,.pdf';

export const CANT_ESTIMATE_LINE =
  "Can't estimate the cost — embedding rates didn't load. You can still proceed.";

export function formatApproximateUsd(usd) {
  return formatEstimateUsd(usd);
}

export function formatWordCount(count) {
  const n = Number(count) || 0;
  return n.toLocaleString('en-US');
}

function appendImportFiles(form, files) {
  files.forEach((entry) => {
    form.append('files', entry.file);
    form.append('declared_formats', entry.declaredFormat);
  });
}

/**
 * Upload a batch into the opened project. Writer declares format per file.
 * Preview is word count + labeled estimate. Proceed parses, embeds, then
 * writes one digest for the batch. Approval is a later call.
 * list() is a read-only offer of landed batches (project Notes room).
 */
export const documentImportApi = {
  list: (projectId) => api.get(`/projects/${projectId}/imports`),
  previewBatch: (projectId, files) => {
    const form = new FormData();
    appendImportFiles(form, files);
    return api.postForm(`/projects/${projectId}/imports/preview`, form);
  },
  createBatch: (projectId, files, { storyId, proseDecisions } = {}) => {
    const form = new FormData();
    appendImportFiles(form, files);
    if (storyId) {
      form.append('story_id', storyId);
    }
    if (proseDecisions) {
      form.append('prose_decisions', JSON.stringify(proseDecisions));
    }
    return api.postForm(`/projects/${projectId}/imports`, form);
  },
  proseCheck: (projectId, files, { storyId } = {}) => {
    const form = new FormData();
    appendImportFiles(form, files);
    if (storyId) form.append('story_id', storyId);
    return api.postForm(`/projects/${projectId}/imports/prose-check`, form);
  },
  suggestFormat: (projectId, files) => {
    const form = new FormData();
    files.forEach((file) => form.append('files', file));
    return api.postForm(`/projects/${projectId}/imports/suggest-format`, form);
  },
  landProseScenes: (projectId, files, { storyId, decisions, batchId } = {}) => {
    const form = new FormData();
    appendImportFiles(form, files);
    if (storyId) form.append('story_id', storyId);
    if (batchId) form.append('batch_id', batchId);
    form.append('decisions', JSON.stringify(decisions || []));
    return api.postForm(`/projects/${projectId}/imports/prose-scenes`, form);
  },
  getDigest: (projectId, batchId) => (
    api.get(`/projects/${projectId}/imports/${batchId}/digest`)
  ),
  generateDigest: (projectId, batchId) => (
    api.post(`/projects/${projectId}/imports/${batchId}/digest`)
  ),
  updateDigest: (projectId, batchId, digest) => (
    api.patch(`/projects/${projectId}/imports/${batchId}/digest`, digest)
  ),
  approveDigest: (projectId, batchId, digest) => (
    api.post(`/projects/${projectId}/imports/${batchId}/digest/approve`, digest)
  ),
  getSourceByChunk: (chunkId) => api.get(`/imports/chunks/${chunkId}`),
};
